var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainHeader'),(_vm.init && (_vm.profile))?_c('Account'):_c('div',[_vm._v("\n    Please log in to see your account settings..\n  ")]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }